class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimeout = null;
    this.hoverOpenMql = window.matchMedia('(min-width: 990px)');
    this.onHeaderMenuPointerEnter = this.onHeaderMenuPointerEnter.bind(this);
    this.onHeaderMenuPointerLeave = this.onHeaderMenuPointerLeave.bind(this);
    this.syncHeaderMenuHoverListeners();

    if (this.hoverOpenMql.addEventListener) {
      this.hoverOpenMql.addEventListener('change', () => this.syncHeaderMenuHoverListeners());
    } else {
      this.hoverOpenMql.addListener(() => this.syncHeaderMenuHoverListeners());
    }
  }

  syncHeaderMenuHoverListeners() {
    this.removeEventListener('pointerenter', this.onHeaderMenuPointerEnter);
    this.removeEventListener('pointerleave', this.onHeaderMenuPointerLeave);
    if (this.hoverCloseTimeout) {
      clearTimeout(this.hoverCloseTimeout);
      this.hoverCloseTimeout = null;
    }

    if (this.hoverOpenMql.matches) {
      this.addEventListener('pointerenter', this.onHeaderMenuPointerEnter);
      this.addEventListener('pointerleave', this.onHeaderMenuPointerLeave);
    }
  }

  onHeaderMenuPointerEnter() {
    if (!this.hoverOpenMql.matches) return;
    if (this.hoverCloseTimeout) {
      clearTimeout(this.hoverCloseTimeout);
      this.hoverCloseTimeout = null;
    }
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  onHeaderMenuPointerLeave() {
    if (!this.hoverOpenMql.matches) return;
    this.hoverCloseTimeout = setTimeout(() => {
      this.close();
      this.hoverCloseTimeout = null;
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
